<section class="why">
  <div class="why-ruler" aria-hidden="true"></div>
  <div class="container why-grid">
    <div>
      <p class="why-eyebrow"><span class="why-eyebrow-num">06</span>#1 in Brooklyn</p>
      <h2 class="why-title">Why 12,000+ contractors run their business on S&amp;F:</h2>
      <div class="why-reasons">
        @for (r of reasons; track r.no) {
        <div class="why-reason">
          <div class="why-no">{{ r.no }}</div>
          <h3 class="why-reason-title">{{ r.title }}</h3>
          <p class="why-reason-text">{{ r.text }}</p>
          <span class="why-meta">{{ r.meta }}</span>
        </div>
        }
      </div>
    </div>

    <div class="why-mapcard">
      <!-- Schematic map, straight from the design file: rings at 5 / 10 / 25 mi, dotted runs
           from Brooklyn out to each delivery point, three trucks (pink dots) riding the runs. -->
      <svg class="why-map" viewBox="0 0 560 560" role="img" aria-label="Schematic same-day delivery zone, 25 miles around Brooklyn">
        <circle cx="280" cy="290" r="114.5" fill="none" stroke="rgba(255,255,255,0.14)" stroke-dasharray="2 5" />
        <text class="why-ring" x="284" y="169.5">5 MI</text>
        <circle cx="280" cy="290" r="161.9" fill="none" stroke="rgba(255,255,255,0.14)" stroke-dasharray="2 5" />
        <text class="why-ring" x="284" y="122.1">10 MI</text>
        <circle cx="280" cy="290" r="256" fill="none" stroke="rgba(255,255,255,0.28)" />
        <text class="why-ring" x="284" y="28">25 MI · SAME-DAY ZONE</text>
        <path d="M8 290H552M280 24V552" stroke="rgba(255,255,255,.08)" />

        <g class="why-runs">
          <path id="why-rt0" d="M280 290Q309.8 237.8 303.8 178" />
          <path id="why-rt1" d="M280 290Q339.5 218.4 346.4 125.6" />
          <path id="why-rt2" d="M280 290Q338.3 195.8 331.1 85.2" />
          <path id="why-rt3" d="M280 290Q365 289.6 434 240" />
          <path id="why-rt4" d="M280 290Q392.8 321.8 503 282.2" />
          <path id="why-rt5" d="M280 290Q243.9 250.2 191.3 238.8" />
          <path id="why-rt6" d="M280 290Q207.7 245.3 122.9 250.8" />
          <path id="why-rt7" d="M280 290Q191 284.2 115.2 331.1" />
          <path id="why-rt8" d="M280 290Q210.3 330.6 177.2 404.1" />
          <path id="why-rt9" d="M280 290Q229.4 177.7 123 115.6" />
        </g>

        <g class="why-points">
          <circle cx="303.8" cy="178" r="4" /><text x="312.8" y="182">MANHATTAN</text>
          <circle cx="346.4" cy="125.6" r="4" /><text x="355.4" y="129.6">BRONX</text>
          <circle cx="331.1" cy="85.2" r="4" /><text x="340.1" y="89.2">YONKERS</text>
          <circle cx="434" cy="240" r="4" /><text x="443" y="244">QUEENS</text>
          <circle cx="503" cy="282.2" r="4" /><text x="507" y="270.2" text-anchor="end">LONG ISLAND</text>
          <circle cx="191.3" cy="238.8" r="4" /><text x="182.3" y="242.8" text-anchor="end">JERSEY CITY</text>
          <circle cx="122.9" cy="250.8" r="4" /><text x="113.9" y="254.8" text-anchor="end">NEWARK</text>
          <circle cx="115.2" cy="331.1" r="4" /><text x="106.2" y="335.1" text-anchor="end">ELIZABETH</text>
          <circle cx="177.2" cy="404.1" r="4" /><text x="168.2" y="408.1" text-anchor="end">STATEN ISLAND</text>
          <circle cx="123" cy="115.6" r="4" /><text x="114" y="119.6" text-anchor="end">PATERSON</text>
        </g>

        <g class="why-trucks">
          <circle r="5"><animateMotion dur="5s" repeatCount="indefinite" rotate="auto"><mpath href="#why-rt0" /></animateMotion></circle>
          <circle r="5"><animateMotion dur="7s" repeatCount="indefinite" rotate="auto"><mpath href="#why-rt6" /></animateMotion></circle>
          <circle r="5"><animateMotion dur="6s" repeatCount="indefinite" rotate="auto"><mpath href="#why-rt3" /></animateMotion></circle>
        </g>

        <circle cx="280" cy="290" r="16" fill="#0A6F93" opacity=".35" />
        <circle cx="280" cy="290" r="8" fill="#F26AAB" />
        <text class="why-hq" x="280" y="324" text-anchor="middle">S&amp;F · BROOKLYN</text>
      </svg>

      <div class="why-ticket" aria-label="Example delivery ticket">
        <div class="why-ticket-main">
          <span class="why-ticket-kicker"><span class="why-live" aria-hidden="true"></span>Same-day · Route 04</span>
          <span class="why-ticket-route">Emerson Pl → Newark</span>
          <div class="why-ticket-rows">
            <span>Your rep<b>Dana R.</b></span>
            <span>Order<b>#SF-40821</b></span>
            <span>ETA<b>2:40 pm</b></span>
          </div>
        </div>
        <div class="why-ticket-stub">
          <span class="why-barcode" aria-hidden="true"></span>
          <span class="why-ontruck">On the truck</span>
        </div>
      </div>

      <div class="why-legend">
        <span><i></i>Our stockroom</span>
        <span><i class="why-legend-run"></i>Same-day runs</span>
        <span><i class="why-legend-point"></i>Delivery points</span>
      </div>
    </div>
  </div>
</section>
